import AmendmentDocument from 'models/AmendmentDocument'
import ShowDataItem from 'models/ShowDataItem'

class PolicyAmendmentDetail {
    constructor(
        amendmentNumber,
        date,
        id,
        insurancePremium,
        policyId,
        status,
        type,
        showData,
        prize,
        validFrom,
        validTo,
        description
    ) {
        this.amendmentNumber = amendmentNumber
        this.date = date
        this.id = id
        this.insurancePremium = insurancePremium
        this.policyId = policyId
        this.status = status
        this.type = type
        this.showData = showData
        this.prize = prize
        this.validFrom = validFrom
        this.validTo = validTo
        this.description = description
    }

    setDocuments(documents) {
        this.documents = documents.map((document) => AmendmentDocument.fromJson(document))
    }

    setDetail(detail) {
        const formattedData = []
        Object.keys(detail).forEach((key) => {
            formattedData.push(ShowDataItem.fromJson({ key, value: detail[key] }))
        })
        this.detail = formattedData
    }

    static fromJson({
        amendmentNumber,
        date,
        documents,
        id,
        insurancePremium,
        policyId,
        status,
        type,
        showData,
        prize,
        validFrom,
        validTo,
        description,
    }) {
        const policyAmendmentDetail = new PolicyAmendmentDetail(
            amendmentNumber,
            date,
            id,
            insurancePremium,
            policyId,
            status,
            type,
            showData,
            prize,
            validFrom,
            validTo,
            description
        )

        if (showData) {
            policyAmendmentDetail.setDetail(showData)
        }

        if (documents) {
            policyAmendmentDetail.setDocuments(documents)
        }

        return policyAmendmentDetail
    }
}

export default PolicyAmendmentDetail
